import React, { useContext } from 'react';
import './projects.css';

import ProjectsCard from './ProjectsCard';
import { DataContext } from '../../context/DataContext';

export default function Projects() {

    const data = useContext(DataContext);
    const myData = data.projectsData;
    
    const project = myData.map(item => {
        return (
            <ProjectsCard 
                key = {item.id}
                myData = {item}
            />
        )
    }) 

    return <>
        <section>
            <h1>Projects</h1>
            <div className='projects--container'>
                <div className="gap-5">
                    {project}
                </div>
            </div>
        </section>
    </>
}
